import React from 'react';
import styled from 'styled-components';
import { Spinner } from '../Spinner';
const AddonContainer = styled.div `
  position: absolute;
  align-self: center;
  right: 0;
`;
export const Addon = ({ disabled, loading, addon }) => {
    if (disabled) {
        return null;
    }
    if (loading) {
        return (React.createElement(AddonContainer, null,
            React.createElement(Spinner, { bottom: "2px", color: "primary", right: "0" })));
    }
    if (addon) {
        return React.createElement(AddonContainer, null, addon);
    }
    return null;
};
//# sourceMappingURL=Addon.js.map